import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Component for protecting routes from unauthenticated users
const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { currentUser, loading } = useAuth();
  
  // Show loading indicator while authentication state is being determined
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  // If roles are specified, check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser.role)) {
    // BIGLI-11：權限不足時退回登入後首頁（導覽總覽頁 /）。
    // 原本退到 /dashboard，但該路由已隨儀表板一起下架，會落到 NotFound——
    // 使用者看到的是 404 而不是「你沒有權限，這是你能去的地方」。
    return <Navigate to="/" replace />;
  }
  
  // Render child routes if authenticated and authorized
  return <Outlet />;
};

export default ProtectedRoute;
